import videoSources from 'shared/constants/video-sources';
import channelTypes from 'shared/constants/channel-types';

import Upload from 'static/images/sources/upload.svg';
import Dropbox from 'static/images/sources/dropbox.svg';
import GoogleDrive from 'static/images/sources/google-drive.svg';
import Youtube from 'static/images/sources/youtube.svg';
import Vimeo from 'static/images/sources/vimeo.svg';
import Facebook from 'static/images/sources/facebook.svg';

import Channel from 'static/images/sources/channel.svg';

import GreyYoutube from 'static/images/sources/grey-youtube.svg';
import GreyVimeo from 'static/images/sources/grey-vimeo.svg';
import GreyFacebook from 'static/images/sources/grey-facebook.svg';


export default {
  [videoSources.COMPUTER]: Upload,
  [videoSources.DROPBOX]: Dropbox,
  [videoSources.GOOGLE_DRIVE]: GoogleDrive,
  [videoSources.YOUTUBE]: Youtube,
  [videoSources.VIMEO]: Vimeo,
  [videoSources.FACEBOOK]: Facebook,

  [channelTypes.CHANNEL]: Channel,
  [channelTypes.YOUTUBE_FEED]: Youtube,
};


export const greyIcons = {
  [videoSources.YOUTUBE]: GreyYoutube,
  [videoSources.VIMEO]: GreyVimeo,
  [videoSources.FACEBOOK]: GreyFacebook,

  [channelTypes.YOUTUBE_FEED]: GreyYoutube,
};



// WEBPACK FOOTER //
// ./src/shared/components/source-icons/source-icons.js